import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetch_preschoolgoals, getLinkedPlansAndDocumententationsForGoal, resetLinkedPlansAndDocumentations, getGoalsStatisticsForUser } from 'actions/preschoolform';
import { Collapsible, Spinner } from 'UI';
import { Flex, Block, translate } from '@haldor/ui';
import './_mentorGoalOverview.scss';
var MentorGoalOverView = /*#__PURE__*/function (_Component) {
  function MentorGoalOverView() {
    var _this;
    _classCallCheck(this, MentorGoalOverView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MentorGoalOverView, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.goals == null || _this.props.goals.length == 0) {
        _this.props.fetch_preschoolgoals();
      }
      if (_this.props.linkedData != null && _this.props.linkedData.length > 0) {
        _this.props.resetLinkedPlansAndDocumentations();
      }
      var _this$props = _this.props,
        userId = _this$props.userId,
        start = _this$props.start,
        end = _this$props.end;
      _this.props.getGoalsStatisticsForUser(userId, start, end);
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.start != _this.props.start || nextProps.end != _this.props.end) {
        var fetchedGoals = [];
        if (_this.props.linkedData != null) {
          _this.props.linkedData.forEach(function (linked) {
            fetchedGoals.push(linked.goalId);
          });
        }
        var userId = _this.props.userId;
        if (fetchedGoals.length > 0) {
          _this.props.resetLinkedPlansAndDocumentations();
          fetchedGoals.forEach(function (id) {
            _this.props.getLinkedPlansAndDocumententationsForGoal(id, nextProps.start, nextProps.end);
          });
        }
        _this.props.getGoalsStatisticsForUser(userId, nextProps.start, nextProps.end);
      }
    });
    _defineProperty(_this, "getCategories", function () {
      var categories = [];
      if (_this.props.goals != null) {
        _this.props.goals.forEach(function (goal) {
          if (!categories.find(function (category) {
            return category.title === goal.group;
          })) {
            categories.push({
              title: goal.group,
              color: goal.colorCode
            });
          }
        });
      }
      return categories;
    });
    _defineProperty(_this, "getGoalsByCategoryName", function (category) {
      var goals = [];
      if (_this.props.goals != null) {
        goals = _toConsumableArray(_this.props.goals).filter(function (goal) {
          return goal.group == category;
        });
      }
      return goals;
    });
    _defineProperty(_this, "onGoalCategoryChange", function (open, goal) {
      var _this$props2 = _this.props,
        userId = _this$props2.userId,
        start = _this$props2.start,
        end = _this$props2.end;
      if (open) {
        var linked = _this.getGoalLinkedData(goal.id);
        if (linked == null) {
          _this.props.getLinkedPlansAndDocumententationsForGoal(goal.id, start, end);
        }
      }
    });
    _defineProperty(_this, "getGoalLinkedData", function (goalId) {
      var linkedData = _this.props.linkedData;
      var data = [];
      if (linkedData != null) {
        var foundGoalData = linkedData.find(function (linked) {
          return linked.goalId == goalId;
        });
        if (foundGoalData != null) {
          foundGoalData.plans.forEach(function (plan) {
            data.push(_objectSpread(_objectSpread({}, plan), {}, {
              type: 'Planning'
            }));
          });
          foundGoalData.documentations.forEach(function (documentation) {
            data.push(_objectSpread(_objectSpread({}, documentation), {}, {
              type: 'documentation'
            }));
          });
        } else {
          // Nothing loaded
          data = null;
        }
      }
      return data;
    });
    _defineProperty(_this, "getGoalBadgeContent", function (goalId) {
      var content = null;
      if (_this.props.statistics != null && _this.props.statistics.length > 0) {
        var foundStatistic = _this.props.statistics[0].statistics.find(function (stat) {
          return stat.goalId == goalId;
        });
        if (foundStatistic != null) {
          content = foundStatistic.total;
        }
      }
      return content;
    });
    _defineProperty(_this, "getCategoryProgress", function (category) {
      var goals = _this.getGoalsByCategoryName(category);
      var categoryCount = 0;
      goals.forEach(function (goal) {
        var goalStatistics = _this.getGoalBadgeContent(goal.id);
        if (goalStatistics != null) {
          categoryCount += 1;
        }
      });
      return categoryCount;
    });
    return _this;
  }
  _inherits(MentorGoalOverView, _Component);
  return _createClass(MentorGoalOverView, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var categories = this.getCategories();
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "mentor-goal-overview"
      }, categories.map(function (category, index) {
        var goals = _this2.getGoalsByCategoryName(category.title);
        return /*#__PURE__*/React.createElement("div", {
          className: "mentor-goal-category",
          key: index
        }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Flex, {
          center: true
        }, /*#__PURE__*/React.createElement("span", {
          className: "title",
          style: {
            marginBottom: 0
          }
        }, category.title), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1,
            textAlign: 'right'
          }
        }, _this2.getCategoryProgress(category.title), "/", goals.length, ' ' + translate('Completed').toLowerCase())), /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '1rem'
          }
        }), goals.map(function (goal) {
          var linked = _this2.getGoalLinkedData(goal.id);
          var badgeContent = _this2.getGoalBadgeContent(goal.id);
          var title = /*#__PURE__*/React.createElement(Flex, {
            center: true,
            space: true
          }, /*#__PURE__*/React.createElement("span", {
            "data-tooltip": goal.text
          }, goal.title), /*#__PURE__*/React.createElement("div", {
            className: "dot-container"
          }, badgeContent != null ? /*#__PURE__*/React.createElement("span", {
            className: "number"
          }, badgeContent) : /*#__PURE__*/React.createElement("span", {
            className: "empty-dot"
          })));
          return /*#__PURE__*/React.createElement(Collapsible, {
            key: goal.id,
            onChange: function onChange(e) {
              return _this2.onGoalCategoryChange(e, goal);
            },
            trigger: title
          }, linked != null ? /*#__PURE__*/React.createElement("div", null, linked.length > 0 ? linked.map(function (item, index) {
            var link = '/plan/' + item.id;
            if (item.type == 'documentation') {
              link = '/documents/' + item.id;
            }
            return /*#__PURE__*/React.createElement(Link, {
              to: link,
              key: 'item' + index,
              className: "linked-item"
            }, item.title, /*#__PURE__*/React.createElement("span", null, item.type == 'documentation' ? translate('Documentation') : translate('Plan')));
          }) : /*#__PURE__*/React.createElement("div", {
            className: "text--center color--meta",
            style: {
              padding: '1rem 0'
            }
          }, translate('No results'))) : /*#__PURE__*/React.createElement("div", {
            style: {
              paddingBottom: '3rem'
            }
          }, /*#__PURE__*/React.createElement(Spinner, {
            small: true,
            center: true
          })));
        })));
      }));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    goals: state.PreschoolGoals.preschoolGoals,
    linkedData: state.PreschoolGoals.linkedData,
    statistics: state.PreschoolGoals.userStatistics
  };
}
export default connect(mapStateToProps, {
  fetch_preschoolgoals: fetch_preschoolgoals,
  getLinkedPlansAndDocumententationsForGoal: getLinkedPlansAndDocumententationsForGoal,
  resetLinkedPlansAndDocumentations: resetLinkedPlansAndDocumentations,
  getGoalsStatisticsForUser: getGoalsStatisticsForUser
})(MentorGoalOverView);